import ExcelJS from 'exceljs';
import IPayslip from "../types/payslip.type";
import ILeave from "../types/leave.type";
import {CellValue, Worksheet} from "exceljs";

interface PayrollRow {
    stt: number;
    mst: string;
    name: string;
    cv: string;
    bp: string;

    luong_hop_dong: number;
    ngay_cong: number;
    luong_ngay_cong: CellValue;

    phu_cap_an_trua: CellValue;
    phu_cap_dien_thoai: CellValue;
    phu_cap_xang_xe: CellValue;
    phu_cap_nha_o: CellValue;
    phu_cap_dao_tao: CellValue;
    phu_cap_cong_nghe: CellValue;
    phu_cap_chuyen_can: CellValue;
    phu_cap_doanh_so: CellValue;

    gio_lam_them_ngay_thuong: CellValue;
    gio_lam_them_ngay_cn: CellValue;
    gio_lam_them_ngay_le: CellValue;
    gio_lam_them_tong: CellValue;

    phu_cap_lam_them_ngay_thuong: CellValue;
    phu_cap_lam_them_ngay_cn: CellValue;
    phu_cap_lam_them_ngay_le: CellValue;
    phu_cap_lam_them_tong: CellValue;

    tong_cong: CellValue;

    trich_theo_luong_bhxh: CellValue;
    trich_theo_luong_bhyt: CellValue;
    trich_theo_luong_bhtn: CellValue;
    trich_theo_luong_bhtnld: CellValue;
    trich_theo_luong_tong: CellValue;

    tru_vao_luong_bhxh: CellValue;
    tru_vao_luong_bhyt: CellValue;
    tru_vao_luong_bhtn: CellValue;
    tru_vao_luong_tong: CellValue;

    tncn_thu_nhap_chiu_thue: CellValue;
    tncn_giam_tru: CellValue;
    tncn_giam_tru_bh: CellValue;
    tncn_thu_nhap_tinh_thue: CellValue;
    tncn_thue: CellValue;

    thuc_linh: CellValue;
    ky_nhan: string;
}

interface PayrollRowCC {
    stt: number;
    name: string;
    cv: string;
    bp: string;

    day_26: string;
    day_27: string;
    day_28: string;
    day_29: string;
    day_30: string;
    day_31: string;
    day_1: string;
    day_2: string;
    day_3: string;
    day_4: string;
    day_5: string;
    day_6: string;
    day_7: string;
    day_8: string;
    day_9: string;
    day_10: string;
    day_11: string;
    day_12: string;
    day_13: string;
    day_14: string;
    day_15: string;
    day_16: string;
    day_17: string;
    day_18: string;
    day_19: string;
    day_20: string;
    day_21: string;
    day_22: string;
    day_23: string;
    day_24: string;
    day_25: string;

    ngay_cong: CellValue;
    di_muon: CellValue;
    ngay_cong_thuong: number;
    ngay_cong_cn: number;
    ngay_cong_le: number;
}

interface IColumn {
    header: string | null;
    key: string | null;
    width: number;
    start: number;
    row: number;
    col: number;
    merge: boolean;
}

function getDayOfMonth(day: number, month: number, year: number): string {
    const days = [
        'CN',
        'T2',
        'T3',
        'T4',
        'T5',
        'T6',
        'T7'
    ];
    return days[new Date(year, month, day).getDay()];
}

function columnNumberToLetter(col: number): string {
    let letter = '';
    while (col > 0) {
        const mod = (col - 1) % 26;
        letter = String.fromCharCode(65 + mod) + letter;
        col = Math.floor((col - 1) / 26);
    }
    return letter;
}

function getCol(sheet: Worksheet, key: string): string {
    return columnNumberToLetter(sheet.getColumn(key).number);
}

function calcHourFromCell(value?: string): number {
    if (!value) return 0;

    // match "5-9", "7 - 11", v.v.
    const match = value.match(/(\d+)\s*-\s*(\d+)/);
    if (!match) return 0;

    const start = Number(match[1]);
    const end = Number(match[2]);

    return Math.abs(end - start);
}

function isWeekend(y: number, m: number, d: number): boolean {
    const dow = new Date(y, m, d).getDay();
    return dow === 0 || dow === 6; // Sunday (0) or Saturday (6)
}

function toUnpaidLeaveArray(unpaidLeaves: unknown): { date?: string }[] {
    if (Array.isArray(unpaidLeaves)) {
        return unpaidLeaves as { date?: string }[];
    }

    if (typeof unpaidLeaves === 'string') {
        try {
            const parsed = JSON.parse(unpaidLeaves);
            return Array.isArray(parsed) ? (parsed as { date?: string }[]) : [];
        } catch {
            return [];
        }
    }

    return [];
}


export async function generatePayslipExcel(month: number, year: number, payslips: IPayslip[], leaves: ILeave[]) {
    const workbook = new ExcelJS.Workbook();

    /* =========================
       SHEET T1 – BẢNG LƯƠNG
    ========================= */
    const sheetT = workbook.addWorksheet('T' + month, {
        pageSetup: {paperSize: 9, orientation: 'landscape'}
    });

    // Set column
    const columns = [
        {header: 'STT', key: 'stt', width: 4, start: 0, row: 3, col: 1, merge: true},
        {header: 'MST', key: 'mst', width: 12, start: 0, row: 3, col: 1, merge: true},
        {header: 'Họ và tên', key: 'name', width: 25, start: 0, row: 3, col: 1, merge: true},
        {header: 'CV', key: 'cv', width: 9, start: 0, row: 3, col: 1, merge: true},
        {header: 'BP', key: 'bp', width: 6, start: 0, row: 3, col: 1, merge: true},
        {header: 'Các khoản được lĩnh', key: null, width: 6, start: 0, row: 1, col: 19, merge: true},
        {header: 'Lương hợp đồng', key: 'luong_hop_dong', width: 13, start: 1, row: 2, col: 1, merge: true},
        {header: 'Ngày công', key: 'ngay_cong', width: 6, start: 1, row: 2, col: 1, merge: true},
        {header: 'Lương ngày công', key: 'luong_ngay_cong', width: 12, start: 1, row: 2, col: 1, merge: true},
        {header: 'Phụ cấp ăn trưa', key: 'phu_cap_an_trua', width: 12, start: 1, row: 2, col: 1, merge: true},
        {header: 'Phụ cấp điện thoại', key: 'phu_cap_dien_thoai', width: 12, start: 1, row: 2, col: 1, merge: true},
        {header: 'Phụ cấp xăng xe', key: 'phu_cap_xang_xe', width: 12, start: 1, row: 2, col: 1, merge: true},
        {header: 'Phụ cấp nhà ở', key: 'phu_cap_nha_o', width: 12, start: 1, row: 2, col: 1, merge: true},
        {header: 'Phụ cấp đào tạo', key: 'phu_cap_dao_tao', width: 12, start: 1, row: 2, col: 1, merge: true},
        {header: 'Phụ cấp công nghệ', key: 'phu_cap_cong_nghe', width: 12, start: 1, row: 2, col: 1, merge: true},
        {header: 'Phụ cấp chuyên cần', key: 'phu_cap_chuyen_can', width: 12, start: 1, row: 2, col: 1, merge: true},
        {header: 'Phụ cấp doanh số', key: 'phu_cap_doanh_so', width: 9, start: 1, row: 2, col: 1, merge: true},
        {header: 'Số giờ làm thêm giờ', key: null, width: 6, start: 1, row: 1, col: 4, merge: true},
        {header: 'Ngày thường', key: 'gio_lam_them_ngay_thuong', width: 8, start: 2, row: 1, col: 1, merge: false},
        {header: 'Ngày CN', key: 'gio_lam_them_ngay_cn', width: 8, start: 2, row: 1, col: 1, merge: false},
        {header: 'Ngày lễ', key: 'gio_lam_them_ngay_le', width: 8, start: 2, row: 1, col: 1, merge: false},
        {header: 'Tổng', key: 'gio_lam_them_tong', width: 8, start: 2, row: 1, col: 1, merge: false},
        {header: 'Phụ cấp làm thêm giờ', key: null, width: 14, start: 1, row: 1, col: 4, merge: true},
        {header: 'Ngày thường', key: 'phu_cap_lam_them_ngay_thuong', width: 12, start: 2, row: 1, col: 1, merge: false},
        {header: 'Ngày CN', key: 'phu_cap_lam_them_ngay_cn', width: 12, start: 2, row: 1, col: 1, merge: false},
        {header: 'Ngày lễ', key: 'phu_cap_lam_them_ngay_le', width: 12, start: 2, row: 1, col: 1, merge: false},
        {header: 'Tổng', key: 'phu_cap_lam_them_tong', width: 12, start: 2, row: 1, col: 1, merge: false},
        {header: 'Tổng cộng', key: 'tong_cong', width: 12, start: 0, row: 3, col: 1, merge: true},
        {header: 'Các khoản BH trích theo lương', key: null, width: 14, start: 0, row: 1, col: 5, merge: true},
        {header: '17%', key: null, width: 11, start: 2, row: 1, col: 0, merge: false},
        {header: 'BHXH', key: 'trich_theo_luong_bhxh', width: 11, start: 1, row: 1, col: 1, merge: false},
        {header: '3%', key: null, width: 11, start: 2, row: 1, col: 0, merge: false},
        {header: 'BHYT', key: 'trich_theo_luong_bhyt', width: 11, start: 1, row: 1, col: 1, merge: false},
        {header: '1%', key: null, width: 11, start: 2, row: 1, col: 0, merge: false},
        {header: 'BHTN', key: 'trich_theo_luong_bhtn', width: 11, start: 1, row: 1, col: 1, merge: false},
        {header: '0.5%', key: null, width: 11, start: 2, row: 1, col: 0, merge: false},
        {header: 'BHTNLĐ', key: 'trich_theo_luong_bhtnld', width: 11, start: 1, row: 1, col: 1, merge: false},
        {header: 'Tổng cộng', key: 'trich_theo_luong_tong', width: 12, start: 1, row: 2, col: 1, merge: true},
        {header: 'Các khoản giảm trừ vào lương', key: null, width: 11, start: 0, row: 1, col: 4, merge: true},
        {header: '8%', key: null, width: 11, start: 2, row: 1, col: 0, merge: false},
        {header: 'BHXH', key: 'tru_vao_luong_bhxh', width: 11, start: 1, row: 1, col: 1, merge: false},
        {header: '1.5%', key: null, width: 11, start: 2, row: 1, col: 0, merge: false},
        {header: 'BHYT', key: 'tru_vao_luong_bhyt', width: 11, start: 1, row: 1, col: 1, merge: false},
        {header: '1%', key: null, width: 11, start: 2, row: 1, col: 0, merge: false},
        {header: 'BHTN', key: 'tru_vao_luong_bhtn', width: 11, start: 1, row: 1, col: 1, merge: false},
        {header: 'Tổng cộng', key: 'tru_vao_luong_tong', width: 12, start: 1, row: 2, col: 1, merge: true},
        {header: 'Thuế TNCN', key: null, width: 11, start: 0, row: 1, col: 5, merge: true},
        {
            header: 'Thu nhập chịu thuế TNCN',
            key: 'tncn_thu_nhap_chiu_thue',
            width: 13,
            start: 1,
            row: 2,
            col: 1,
            merge: true
        },
        {header: 'Giảm trừ', key: 'tncn_giam_tru', width: 11, start: 1, row: 2, col: 1, merge: true},
        {header: 'Giảm trừ BH', key: 'tncn_giam_tru_bh', width: 11, start: 1, row: 2, col: 1, merge: true},
        {
            header: 'Thu nhập tính thuế TNCN',
            key: 'tncn_thu_nhap_tinh_thue',
            width: 12,
            start: 1,
            row: 2,
            col: 1,
            merge: true
        },
        {header: 'Thuế TNCN', key: 'tncn_thue', width: 11, start: 1, row: 2, col: 1, merge: true},
        {header: 'Thực lĩnh', key: 'thuc_linh', width: 14, start: 0, row: 3, col: 1, merge: true},
        {header: 'Ký nhận', key: 'ky_nhan', width: 18, start: 0, row: 3, col: 1, merge: true}
    ] as IColumn[];

    sheetT.columns = columns
        .filter(col => col.key !== null)
        .map(col => ({
            header: col.header ?? '',
            key: col.key as string,
            width: col.width
        } as ExcelJS.Column));

    // Title
    sheetT.mergeCells('A1:AO1');
    sheetT.getCell('A1').value = 'CÔNG TY CỔ PHẦN BBOLD';
    sheetT.getCell('A1').font = {bold: true, size: 12, name: 'Times New Roman'};
    sheetT.getCell('A1').alignment = {horizontal: 'left'};

    sheetT.mergeCells('A2:AO2');
    sheetT.getCell('A2').value = 'Tầng 5, Số nhà 78 Đường Nguyễn Khang, Phường Yên Hoà, Quận Cầu Giấy, Thành phố Hà Nội, Việt Nam';
    sheetT.getCell('A2').font = {size: 12, name: 'Times New Roman'};
    sheetT.getCell('A2').alignment = {horizontal: 'left'};

    sheetT.mergeCells('A4:AO4');
    sheetT.getCell('A4').value = 'BẢNG THANH TOÁN TIỀN LƯƠNG';
    sheetT.getCell('A4').font = {bold: true, size: 18, name: 'Times New Roman'};
    sheetT.getCell('A4').alignment = {horizontal: 'center'};

    sheetT.mergeCells('A5:AO5');
    sheetT.getCell('A5').value = 'Tháng ' + month + ' năm ' + year;
    sheetT.getCell('A5').font = {bold: true, size: 14, name: 'Times New Roman'};
    sheetT.getCell('A5').alignment = {horizontal: 'center'};

    const startRow = 7;
    let colIndex = 1;
    columns.forEach((col, index) => {
        if (col.merge) {
            sheetT.mergeCells(startRow + col.start, colIndex, startRow + col.start + col.row - 1, colIndex + col.col - 1);
        }
        let cell = sheetT.getCell(startRow + col.start, colIndex);
        cell.value = col.header as string;
        cell.border = {
            top: {style: 'thin'},
            left: {style: 'thin'},
            bottom: {style: 'thin'},
            right: {style: 'thin'}
        };
        cell.font = {bold: true, name: 'Times New Roman'};
        cell.alignment = {wrapText: true, horizontal: 'center', vertical: 'middle'};
        if (col.key != null) {
            colIndex++;
        }
    });

    payslips.filter(payslip => Number(payslip.payroll.base_salary!) > 0)
        .map((payslip, index) => {
            let salary_breakdown = {} as Record<string, number>;
            if (payslip.payroll.salary_breakdown) {
                salary_breakdown = JSON.parse(payslip.payroll.salary_breakdown) as Record<string, number>;
            }
            const ngay_cong = payslip.payroll.paid_full == 1 ? Number(payslip.total_working_days!) : Number(payslip?.paid_working_days!) + Number(payslip?.paid_leave!) + Number(payslip?.annual_leave!);
            let gio_lam_them_ngay_thuong = 0;
            let gio_lam_them_ngay_cn = 0;
            let gio_lam_them_ngay_le = 0;
            payslip.overtimes?.forEach(ot => {
                if (ot.ot_type == 0) {
                    gio_lam_them_ngay_thuong += Number(ot.ot_hour!);
                } else if (ot.ot_type == 1) {
                    gio_lam_them_ngay_cn += Number(ot.ot_hour!);
                } else if (ot.ot_type == 2) {
                    gio_lam_them_ngay_le += Number(ot.ot_hour!);
                }
            });

            const rowIndex = sheetT.rowCount + 1;
            const salary = Object.values(salary_breakdown)
                .filter(v => !Number.isNaN(v))
                .reduce((sum, v) => sum + v, 0);

            const isProbationary = payslip.employee_type === 'probationary';

            const row = sheetT.addRow({
                stt: index + 1,
                mst: payslip.user?.cccd!,
                name: payslip.user?.name!,
                cv: payslip.user?.title == "CEO" ? "GD" : isProbationary ? "TV" : "NV",
                bp: 'SX',
                luong_hop_dong: salary_breakdown['luong_hop_dong'],
                ngay_cong: ngay_cong,
                luong_ngay_cong: {formula: `${getCol(sheetT, 'luong_hop_dong')}${rowIndex} * ${getCol(sheetT, 'ngay_cong')}${rowIndex} / ${Number(payslip.total_working_days!)}`},

                phu_cap_an_trua: {formula: `${salary_breakdown['phu_cap_an_trua']} * ${getCol(sheetT, 'ngay_cong')}${rowIndex} / ${Number(payslip.total_working_days!)}`},
                phu_cap_dien_thoai: {formula: `${salary_breakdown['phu_cap_dien_thoai']} * ${getCol(sheetT, 'ngay_cong')}${rowIndex} / ${Number(payslip.total_working_days!)}`},
                phu_cap_xang_xe: {formula: `${salary_breakdown['phu_cap_xang_xe']} * ${getCol(sheetT, 'ngay_cong')}${rowIndex} / ${Number(payslip.total_working_days!)}`},
                phu_cap_nha_o: {formula: `${salary_breakdown['phu_cap_nha_o']} * ${getCol(sheetT, 'ngay_cong')}${rowIndex} / ${Number(payslip.total_working_days!)}`},
                phu_cap_dao_tao: {formula: `${salary_breakdown['phu_cap_dao_tao']} * ${getCol(sheetT, 'ngay_cong')}${rowIndex} / ${Number(payslip.total_working_days!)}`},
                phu_cap_cong_nghe: {formula: `${salary_breakdown['phu_cap_cong_nghe']} * ${getCol(sheetT, 'ngay_cong')}${rowIndex} / ${Number(payslip.total_working_days!)}`},
                phu_cap_chuyen_can: {formula: `${salary_breakdown['phu_cap_chuyen_can']} * ${getCol(sheetT, 'ngay_cong')}${rowIndex} / ${Number(payslip.total_working_days!)} - ${Number(payslip.amercement)}`},
                phu_cap_doanh_so: {formula: `${salary_breakdown['phu_cap_doanh_so']} * ${getCol(sheetT, 'ngay_cong')}${rowIndex} / ${Number(payslip.total_working_days!)}`},

                gio_lam_them_ngay_thuong: gio_lam_them_ngay_thuong,
                gio_lam_them_ngay_cn: gio_lam_them_ngay_cn,
                gio_lam_them_ngay_le: gio_lam_them_ngay_le,
                gio_lam_them_tong: {formula: `ROUND(${getCol(sheetT, 'gio_lam_them_ngay_thuong')}${rowIndex}+${getCol(sheetT, 'gio_lam_them_ngay_cn')}${rowIndex}+${getCol(sheetT, 'gio_lam_them_ngay_le')}${rowIndex}, 0)`},

                phu_cap_lam_them_ngay_thuong: {formula: `ROUND(${getCol(sheetT, 'gio_lam_them_ngay_thuong')}${rowIndex} * (${salary} / ${Number(payslip.total_working_days!)} / 8) * 150%, 0)`},
                phu_cap_lam_them_ngay_cn: {formula: `ROUND(${getCol(sheetT, 'gio_lam_them_ngay_cn')}${rowIndex} * (${salary} / ${Number(payslip.total_working_days!)} / 8) * 200%, 0)`},
                phu_cap_lam_them_ngay_le: {formula: `ROUND(${getCol(sheetT, 'gio_lam_them_ngay_le')}${rowIndex} * (${salary} / ${Number(payslip.total_working_days!)} / 8) * 300%, 0)`},
                phu_cap_lam_them_tong: {formula: `ROUND(${getCol(sheetT, 'phu_cap_lam_them_ngay_thuong')}${rowIndex}+${getCol(sheetT, 'phu_cap_lam_them_ngay_cn')}${rowIndex}+${getCol(sheetT, 'phu_cap_lam_them_ngay_le')}${rowIndex}, 0)`},

                tong_cong: {formula: `ROUND(SUM(${getCol(sheetT, 'luong_ngay_cong')}${rowIndex}:${getCol(sheetT, 'phu_cap_doanh_so')}${rowIndex})+${getCol(sheetT, 'phu_cap_lam_them_tong')}${rowIndex}, 0)`},

                // Probationary: no insurance (BH = 0)
                trich_theo_luong_bhxh: isProbationary ? 0 : {formula: `ROUND(${getCol(sheetT, 'luong_hop_dong')}${rowIndex} * 17%, 0)`},
                trich_theo_luong_bhyt: isProbationary ? 0 : {formula: `ROUND(${getCol(sheetT, 'luong_hop_dong')}${rowIndex} * 3%, 0)`},
                trich_theo_luong_bhtn: isProbationary ? 0 : {formula: `ROUND(${getCol(sheetT, 'luong_hop_dong')}${rowIndex} * 1%, 0)`},
                trich_theo_luong_bhtnld: isProbationary ? 0 : {formula: `ROUND(${getCol(sheetT, 'luong_hop_dong')}${rowIndex} * 0.5%, 0)`},
                trich_theo_luong_tong: isProbationary ? 0 : {formula: `ROUND(SUM(${getCol(sheetT, 'trich_theo_luong_bhxh')}${rowIndex}:${getCol(sheetT, 'trich_theo_luong_bhtnld')}${rowIndex}), 0)`},

                tru_vao_luong_bhxh: isProbationary ? 0 : {formula: `ROUND(${getCol(sheetT, 'luong_hop_dong')}${rowIndex} * 8%, 0)`},
                tru_vao_luong_bhyt: isProbationary ? 0 : {formula: `ROUND(${getCol(sheetT, 'luong_hop_dong')}${rowIndex} * 1.5%, 0)`},
                tru_vao_luong_bhtn: isProbationary ? 0 : {formula: `ROUND(${getCol(sheetT, 'luong_hop_dong')}${rowIndex} * 1%, 0)`},
                tru_vao_luong_tong: isProbationary ? 0 : {formula: `ROUND(SUM(${getCol(sheetT, 'tru_vao_luong_bhxh')}${rowIndex}:${getCol(sheetT, 'tru_vao_luong_bhtn')}${rowIndex}), 0)`},

                // Probationary: TNCN flat 10%, no personal/BH deductions
                tncn_thu_nhap_chiu_thue: {formula: `ROUND(${getCol(sheetT, 'tong_cong')}${rowIndex} - ${getCol(sheetT, 'phu_cap_an_trua')}${rowIndex} - ${getCol(sheetT, 'phu_cap_lam_them_tong')}${rowIndex}, 0)`},
                tncn_giam_tru: isProbationary ? 0 : 15500000 + 6000000 * (payslip.dependent ? payslip.dependent : 0),
                tncn_giam_tru_bh: isProbationary ? 0 : {formula: `${getCol(sheetT, 'tru_vao_luong_tong')}${rowIndex}`},
                tncn_thu_nhap_tinh_thue: isProbationary
                    ? {formula: `ROUND(${getCol(sheetT, 'tncn_thu_nhap_chiu_thue')}${rowIndex}, 0)`}
                    : {formula: `ROUND(IF(${getCol(sheetT, 'tncn_thu_nhap_chiu_thue')}${rowIndex} - ${getCol(sheetT, 'tncn_giam_tru')}${rowIndex} - ${getCol(sheetT, 'tncn_giam_tru_bh')}${rowIndex}>0,${getCol(sheetT, 'tncn_thu_nhap_chiu_thue')}${rowIndex} - ${getCol(sheetT, 'tncn_giam_tru')}${rowIndex} - ${getCol(sheetT, 'tncn_giam_tru_bh')}${rowIndex},0), 0)`},
                tncn_thue: isProbationary
                    ? {formula: `ROUND(${getCol(sheetT, 'tncn_thu_nhap_chiu_thue')}${rowIndex} * 10%, 0)`}
                    : {formula: `ROUND(IF(${getCol(sheetT, 'tncn_thu_nhap_tinh_thue')}${rowIndex}<=10000000,${getCol(sheetT, 'tncn_thu_nhap_tinh_thue')}${rowIndex}*5%,IF(${getCol(sheetT, 'tncn_thu_nhap_tinh_thue')}${rowIndex}<=30000000,${getCol(sheetT, 'tncn_thu_nhap_tinh_thue')}${rowIndex}*10%-500000,IF(${getCol(sheetT, 'tncn_thu_nhap_tinh_thue')}${rowIndex}<=60000000,${getCol(sheetT, 'tncn_thu_nhap_tinh_thue')}${rowIndex}*20%-3500000,IF(${getCol(sheetT, 'tncn_thu_nhap_tinh_thue')}${rowIndex}<=100000000,${getCol(sheetT, 'tncn_thu_nhap_tinh_thue')}${rowIndex}*30%-9500000,${getCol(sheetT, 'tncn_thu_nhap_tinh_thue')}${rowIndex}*35%-14500000)))), 0)`},
                // thuc_linh unchanged: tru_vao_luong_tong=0 for probationary, so formula is correct for both
                thuc_linh: {formula: `ROUND(${getCol(sheetT, 'tong_cong')}${rowIndex} - ${getCol(sheetT, 'tru_vao_luong_tong')}${rowIndex} - ${getCol(sheetT, 'tncn_thue')}${rowIndex}, 0)`},
                ky_nhan: ''
            } as PayrollRow);

            row.eachCell(cell => {
                cell.border = {
                    top: {style: 'thin'},
                    left: {style: 'thin'},
                    bottom: {style: 'thin'},
                    right: {style: 'thin'}
                };
                cell.font = {name: 'Times New Roman'};
                cell.alignment = {vertical: 'middle'};
            });
            row.height = 24;
        });

    const totalRow = sheetT.addRow({
        name: 'Tổng cộng',
    } as PayrollRow);

    const totalRowIndex = totalRow.number;
    [
        'luong_hop_dong',
        'ngay_cong',
        'luong_ngay_cong',

        'phu_cap_an_trua',
        'phu_cap_dien_thoai',
        'phu_cap_xang_xe',
        'phu_cap_nha_o',
        'phu_cap_dao_tao',
        'phu_cap_cong_nghe',
        'phu_cap_chuyen_can',
        'phu_cap_doanh_so',

        'gio_lam_them_ngay_thuong',
        'gio_lam_them_ngay_cn',
        'gio_lam_them_ngay_le',
        'gio_lam_them_tong',

        'phu_cap_lam_them_ngay_thuong',
        'phu_cap_lam_them_ngay_cn',
        'phu_cap_lam_them_ngay_le',
        'phu_cap_lam_them_tong',

        'tong_cong',

        'trich_theo_luong_bhxh',
        'trich_theo_luong_bhyt',
        'trich_theo_luong_bhtn',
        'trich_theo_luong_bhtnld',
        'trich_theo_luong_tong',

        'tru_vao_luong_bhxh',
        'tru_vao_luong_bhyt',
        'tru_vao_luong_bhtn',
        'tru_vao_luong_tong',

        'tncn_thu_nhap_chiu_thue',
        'tncn_giam_tru',
        'tncn_giam_tru_bh',
        'tncn_thu_nhap_tinh_thue',
        'tncn_thue',
        'thuc_linh'
    ].forEach(key => {
        const column = sheetT.getColumn(key as string);
        const colLetter = columnNumberToLetter(column.number);

        sheetT.getCell(`${colLetter}${totalRowIndex}`).value = {
            formula: `SUM(${colLetter}${startRow}:${colLetter}${totalRowIndex - 1})`
        };
    });

    totalRow.eachCell(cell => {
        cell.border = {
            top: {style: 'thin'},
            left: {style: 'thin'},
            bottom: {style: 'thin'},
            right: {style: 'thin'}
        };
        cell.font = {name: 'Times New Roman', bold: true};
        cell.alignment = {vertical: 'middle'};
    });
    totalRow.height = 24;

    // Format money columns
    ['luong_hop_dong', 'luong_ngay_cong', 'phu_cap_an_trua', 'phu_cap_dien_thoai', 'phu_cap_xang_xe', 'phu_cap_nha_o', 'phu_cap_dao_tao', 'phu_cap_cong_nghe', 'phu_cap_chuyen_can', 'phu_cap_doanh_so',
        'phu_cap_lam_them_ngay_thuong', 'phu_cap_lam_them_ngay_cn', 'phu_cap_lam_them_ngay_le', 'phu_cap_lam_them_tong', 'tong_cong',
        'trich_theo_luong_bhxh', 'trich_theo_luong_bhyt', 'trich_theo_luong_bhtn', 'trich_theo_luong_bhtnld', 'trich_theo_luong_tong',
        'tru_vao_luong_bhxh', 'tru_vao_luong_bhyt', 'tru_vao_luong_bhtn', 'tru_vao_luong_tong',
        'tncn_thu_nhap_chiu_thue', 'tncn_giam_tru', 'tncn_giam_tru_bh', 'tncn_thu_nhap_tinh_thue', 'tncn_thue', 'thuc_linh']
        .forEach(key => {
            sheetT.getColumn(key).numFmt = '#,##0';
        });

    // Freeze header
    // sheet.views = [{state: 'frozen', ySplit: 7}];

    /* =========================
       SHEET CHAM CONG
    ========================= */
    const sheetCC = workbook.addWorksheet('CC' + month, {
        pageSetup: {paperSize: 9, orientation: 'landscape'}
    });

    const numberOfDaysInMonth = new Date(year, month - 1, 0).getDate();

    // Set column
    const columnsCC = [
        {header: 'STT', key: 'stt', width: 4, start: 0, row: 3, col: 1, merge: true},
        {header: 'Họ và tên', key: 'name', width: 25, start: 0, row: 3, col: 1, merge: true},
        {header: 'CV', key: 'cv', width: 9, start: 0, row: 3, col: 1, merge: true},
        {header: 'BP', key: 'bp', width: 6, start: 0, row: 3, col: 1, merge: true},
        {header: 'Ngày trong tháng', key: null, width: 6, start: 0, row: 1, col: numberOfDaysInMonth, merge: true}
    ] as IColumn[];

    for (let day = 26; day <= numberOfDaysInMonth; day++) {
        columnsCC.push({
            header: getDayOfMonth(day, month - 2, year),
            key: null,
            width: 4,
            start: 2,
            row: 1,
            col: 1,
            merge: false
        } as IColumn);
        columnsCC.push({
            header: day + '',
            key: 'day_' + day,
            width: 4,
            start: 1,
            row: 1,
            col: 1,
            merge: false
        } as IColumn);
    }

    for (let day = 1; day <= 25; day++) {
        columnsCC.push({
            header: getDayOfMonth(day, month - 1, year),
            key: null,
            width: 4,
            start: 2,
            row: 1,
            col: 1,
            merge: false
        } as IColumn);
        columnsCC.push({
            header: day + '',
            key: 'day_' + day,
            width: 4,
            start: 1,
            row: 1,
            col: 1,
            merge: false
        } as IColumn);
    }

    columnsCC.push({
        header: payslips[0].total_working_days + '',
        key: null,
        width: 14,
        start: 2,
        row: 1,
        col: 1,
        merge: false
    } as IColumn);
    columnsCC.push({
        header: 'Số công trong tháng',
        key: 'ngay_cong',
        width: 14,
        start: 0,
        row: 2,
        col: 1,
        merge: true
    } as IColumn);
    columnsCC.push({
        header: 'Số phút đi muộn',
        key: 'di_muon',
        width: 14,
        start: 0,
        row: 3,
        col: 1,
        merge: true
    } as IColumn);

    sheetCC.columns = columnsCC
        .filter(col => col.key !== null)
        .map(col => ({
            header: col.header ?? '',
            key: col.key as string,
            width: col.width
        } as ExcelJS.Column));

    // Title
    sheetCC.mergeCells('A1:AK1');
    sheetCC.getCell('A1').value = 'CÔNG TY CỔ PHẦN BBOLD';
    sheetCC.getCell('A1').font = {bold: true, size: 12, name: 'Times New Roman'};
    sheetCC.getCell('A1').alignment = {horizontal: 'left'};

    sheetCC.mergeCells('A2:AK2');
    sheetCC.getCell('A2').value = 'Tầng 5, Số nhà 78 Đường Nguyễn Khang, Phường Yên Hoà, Quận Cầu Giấy, Thành phố Hà Nội, Việt Nam';
    sheetCC.getCell('A2').font = {size: 12, name: 'Times New Roman'};
    sheetCC.getCell('A2').alignment = {horizontal: 'left'};

    sheetCC.mergeCells('A4:AK4');
    sheetCC.getCell('A4').value = 'BẢNG CHẤM CÔNG';
    sheetCC.getCell('A4').font = {bold: true, size: 18, name: 'Times New Roman'};
    sheetCC.getCell('A4').alignment = {horizontal: 'center'};

    sheetCC.mergeCells('A5:AK5');
    sheetCC.getCell('A5').value = 'Tháng ' + month + ' năm ' + year;
    sheetCC.getCell('A5').font = {bold: true, size: 14, name: 'Times New Roman'};
    sheetCC.getCell('A5').alignment = {horizontal: 'center'};

    const startRowCC = 7;
    let colIndexCC = 1;
    columnsCC.forEach((col, index) => {
        if (col.merge) {
            sheetCC.mergeCells(startRowCC + col.start, colIndexCC, startRowCC + col.start + col.row - 1, colIndexCC + col.col - 1);
        }
        let cell = sheetCC.getCell(startRowCC + col.start, colIndexCC);
        cell.value = col.header as string;
        cell.border = {
            top: {style: 'thin'},
            left: {style: 'thin'},
            bottom: {style: 'thin'},
            right: {style: 'thin'}
        };
        cell.font = {bold: true, name: 'Times New Roman'};
        cell.alignment = {wrapText: true, horizontal: 'center', vertical: 'middle'};
        if (col.key != null) {
            colIndexCC++;
        }
    });

    const dataCC: PayrollRowCC[] = payslips
        .filter(payslip => Number(payslip.payroll.base_salary!) > 0)
        .map((payslip, index) => {
            let iLeaves = leaves.filter(leave => leave.email == payslip.user?.email && leave.approve == 1 && (leave.type == 'Casual' || leave.type == 'Sick'));

            const getDayCell = (day: number, monthForString: number, monthIndexForDate: number) => {
                if (isWeekend(year, monthIndexForDate, day)) return '';
                const dateStr = `${year}-${String(monthForString).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
                const unpaidLeaves = toUnpaidLeaveArray(payslip.unpaid_leaves);
                if (unpaidLeaves.some((leave) => leave?.date === dateStr)) return 'o';
                return iLeaves.some(leave => leave.start === dateStr) ? 'o' : 'x';
            };

            const dayValuesCC: Record<string, string> = {};
            for (let day = 26; day <= numberOfDaysInMonth; day++) {
                dayValuesCC['day_' + day] = getDayCell(day, month - 1, month - 2);
            }
            for (let day = 1; day <= 25; day++) {
                dayValuesCC['day_' + day] = getDayCell(day, month, month - 1);
            }

            const isProbationary = payslip.employee_type === 'probationary';

            const ngay_cong = payslip.payroll.paid_full == 1 ? Number(payslip.total_working_days!) : Number(payslip?.paid_working_days!) + Number(payslip?.paid_leave!) + Number(payslip?.annual_leave!);
            const di_muon = Number(payslip?.amercement! / 1000);
            return ({
                stt: index + 1,
                name: payslip.user?.name!,
                cv: payslip.user?.title == "CEO" ? "GD" : isProbationary ? "TV" : "NV",
                bp: 'SX',
                ...dayValuesCC,
                ngay_cong: ngay_cong,
                di_muon: di_muon
            }) as PayrollRowCC
        }) as PayrollRowCC[];

    // Add data rows
    dataCC.forEach(item => {
        const row = sheetCC.addRow(item);

        row.eachCell(cell => {
            cell.border = {
                top: {style: 'thin'},
                left: {style: 'thin'},
                bottom: {style: 'thin'},
                right: {style: 'thin'}
            };
            cell.font = {name: 'Times New Roman', size: 12};
            cell.alignment = {vertical: 'middle', horizontal: 'center'};
        });
        row.height = 24;
    });

    const totalRowCC = sheetCC.addRow({
        name: 'Tổng cộng',
    } as PayrollRowCC);
    const startRowData = 10;
    const totalRowIndexCC = totalRowCC.number;
    const dayKeysCC: string[] = [];
    for (let day = 26; day <= numberOfDaysInMonth; day++) {
        dayKeysCC.push('day_' + day);
    }
    for (let day = 1; day <= 25; day++) {
        dayKeysCC.push('day_' + day);
    }
    dayKeysCC.forEach(key => {
        const column = sheetCC.getColumn(key as string);
        const colLetter = columnNumberToLetter(column.number);

        sheetCC.getCell(`${colLetter}${totalRowIndexCC}`).value = {
            formula: `IF(COUNTIF(${colLetter}${startRowData}:${colLetter}${totalRowIndexCC - 1},"x") + COUNTIF(${colLetter}${startRowData}:${colLetter}${totalRowIndexCC - 1},"o") = 0, "", COUNTIF(${colLetter}${startRowData}:${colLetter}${totalRowIndexCC - 1},"x"))`.replace(/\s+/g, '')
        };
    });

    const weekendColumns: string[] = [];
    for (let day = 26; day <= numberOfDaysInMonth; day++) {
        if (isWeekend(year, month - 2, day)) {
            weekendColumns.push('day_' + day);
        }
    }

    for (let day = 1; day <= 25; day++) {
        if (isWeekend(year, month - 1, day)) {
            weekendColumns.push('day_' + day);
        }
    }

    weekendColumns.forEach(key => {
        const colLetter = getCol(sheetCC, key);
        for (let row = startRow + 1; row <= totalRowIndexCC; row++) {
            sheetCC.getCell(`${colLetter}${row}`).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: {argb: 'FFD9D9D9'}
            };
        }
    });

    const column = sheetCC.getColumn('ngay_cong');
    const colLetter = columnNumberToLetter(column.number);

    sheetCC.getCell(`${colLetter}${totalRowIndexCC}`).value = {
        formula: `SUM(${colLetter}${startRowData}:${colLetter}${totalRowIndexCC - 1})`
    };
    const column1 = sheetCC.getColumn('di_muon');
    const colLetter1 = columnNumberToLetter(column1.number);

    sheetCC.getCell(`${colLetter1}${totalRowIndexCC}`).value = {
        formula: `SUM(${colLetter1}${startRowData}:${colLetter1}${totalRowIndexCC - 1})`
    };

    totalRowCC.eachCell(cell => {
        cell.border = {
            top: {style: 'thin'},
            left: {style: 'thin'},
            bottom: {style: 'thin'},
            right: {style: 'thin'}
        };
        cell.font = {name: 'Times New Roman', bold: true};
        cell.alignment = {vertical: 'middle', horizontal: 'center'};
    });
    totalRowCC.height = 24;

    /* =========================
       SHEET CHAM CONG LAM THEM GIO
    ========================= */
    const sheetOT = workbook.addWorksheet('TG' + month, {
        pageSetup: {paperSize: 9, orientation: 'landscape'}
    });

    // Set column
    const columnsOT = [
        {header: 'STT', key: 'stt', width: 4, start: 0, row: 3, col: 1, merge: true},
        {header: 'Họ và tên', key: 'name', width: 25, start: 0, row: 3, col: 1, merge: true},
        {header: 'CV', key: 'cv', width: 9, start: 0, row: 3, col: 1, merge: true},
        {header: 'BP', key: 'bp', width: 6, start: 0, row: 3, col: 1, merge: true},
        {header: 'Ngày trong tháng', key: null, width: 6, start: 0, row: 1, col: numberOfDaysInMonth, merge: true}
    ] as IColumn[];

    for (let day = 26; day <= numberOfDaysInMonth; day++) {
        columnsOT.push({
            header: getDayOfMonth(day, month - 2, year),
            key: null,
            width: 10,
            start: 2,
            row: 1,
            col: 1,
            merge: false
        } as IColumn);
        columnsOT.push({
            header: day + '',
            key: 'day_' + day,
            width: 10,
            start: 1,
            row: 1,
            col: 1,
            merge: false
        } as IColumn);
    }

    for (let day = 1; day <= 25; day++) {
        columnsOT.push({
            header: getDayOfMonth(day, month - 1, year),
            key: null,
            width: 10,
            start: 2,
            row: 1,
            col: 1,
            merge: false
        } as IColumn);
        columnsOT.push({
            header: day + '',
            key: 'day_' + day,
            width: 10,
            start: 1,
            row: 1,
            col: 1,
            merge: false
        } as IColumn);
    }

    columnsOT.push({header: 'Cộng giờ làm thêm', key: null, width: 6, start: 0, row: 1, col: 4, merge: true},
        {header: 'Ngày thường', key: 'ngay_cong_thuong', width: 8, start: 1, row: 2, col: 1, merge: true},
        {header: 'Ngày CN', key: 'ngay_cong_cn', width: 8, start: 1, row: 2, col: 1, merge: true},
        {header: 'Ngày lễ', key: 'ngay_cong_le', width: 8, start: 1, row: 2, col: 1, merge: true},
        {header: 'Tổng', key: 'ngay_cong', width: 8, start: 1, row: 2, col: 1, merge: true});

    sheetOT.columns = columnsOT
        .filter(col => col.key !== null)
        .map(col => ({
            header: col.header ?? '',
            key: col.key as string,
            width: col.width
        } as ExcelJS.Column));

    // Title
    sheetOT.mergeCells('A1:AM1');
    sheetOT.getCell('A1').value = 'CÔNG TY CỔ PHẦN BBOLD';
    sheetOT.getCell('A1').font = {bold: true, size: 12, name: 'Times New Roman'};
    sheetOT.getCell('A1').alignment = {horizontal: 'left'};

    sheetOT.mergeCells('A2:AM2');
    sheetOT.getCell('A2').value = 'Tầng 5, Số nhà 78 Đường Nguyễn Khang, Phường Yên Hoà, Quận Cầu Giấy, Thành phố Hà Nội, Việt Nam';
    sheetOT.getCell('A2').font = {size: 12, name: 'Times New Roman'};
    sheetOT.getCell('A2').alignment = {horizontal: 'left'};

    sheetOT.mergeCells('A4:AM4');
    sheetOT.getCell('A4').value = 'BẢNG CHẤM CÔNG LÀM THÊM GIỜ';
    sheetOT.getCell('A4').font = {bold: true, size: 18, name: 'Times New Roman'};
    sheetOT.getCell('A4').alignment = {horizontal: 'center'};

    sheetOT.mergeCells('A5:AM5');
    sheetOT.getCell('A5').value = 'Tháng ' + month + ' năm ' + year;
    sheetOT.getCell('A5').font = {bold: true, size: 14, name: 'Times New Roman'};
    sheetOT.getCell('A5').alignment = {horizontal: 'center'};

    const startRowOT = 7;
    let colIndexOT = 1;
    columnsOT.forEach((col, index) => {
        if (col.merge) {
            sheetOT.mergeCells(startRowOT + col.start, colIndexOT, startRowOT + col.start + col.row - 1, colIndexOT + col.col - 1);
        }
        let cell = sheetOT.getCell(startRowOT + col.start, colIndexOT);
        cell.value = col.header as string;
        cell.border = {
            top: {style: 'thin'},
            left: {style: 'thin'},
            bottom: {style: 'thin'},
            right: {style: 'thin'}
        };
        cell.font = {bold: true, name: 'Times New Roman'};
        cell.alignment = {wrapText: true, horizontal: 'center', vertical: 'middle'};
        if (col.key != null) {
            colIndexOT++;
        }
    });

    payslips
        .filter(payslip => Number(payslip.payroll.base_salary!) > 0 && Number(payslip.overtimes!.length) > 0)
        .map((payslip, index) => {
            const isWeekend = (y: number, m: number, d: number) => {
                const dow = new Date(y, m, d).getDay();
                return dow === 0 || dow === 6; // Sunday (0) or Saturday (6)
            };

            const getDayCell = (day: number, monthForString: number, monthIndexForDate: number) => {
                const dateStr = `${year}-${String(monthForString).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
                const ot = payslip.overtimes!.find(leave => leave.date === dateStr);
                if (ot) {
                    return isWeekend(year, monthIndexForDate, day) ? ('NN: 8-' + (8 + Number(ot.ot_hour))) : 'NT: 5-' + (5 + Number(ot.ot_hour));
                }
                return '';
            };

            const dayValuesOT: Record<string, string> = {};
            for (let day = 26; day <= numberOfDaysInMonth; day++) {
                dayValuesOT['day_' + day] = getDayCell(day, month - 1, month - 2);
            }
            for (let day = 1; day <= 25; day++) {
                dayValuesOT['day_' + day] = getDayCell(day, month, month - 1);
            }

            let gio_lam_them_ngay_thuong = 0;
            let gio_lam_them_ngay_cn = 0;
            let gio_lam_them_ngay_le = 0;
            payslip.overtimes?.forEach(ot => {
                if (ot.ot_type == 0) {
                    gio_lam_them_ngay_thuong += Number(ot.ot_hour!);
                } else if (ot.ot_type == 1) {
                    gio_lam_them_ngay_cn += Number(ot.ot_hour!);
                } else if (ot.ot_type == 2) {
                    gio_lam_them_ngay_le += Number(ot.ot_hour!);
                }
            });

            const isProbationary = payslip.employee_type === 'probationary';

            const rowIndex = sheetOT.rowCount + 1;

            const row = sheetOT.addRow({
                stt: index + 1,
                name: payslip.user?.name!,
                cv: payslip.user?.title == "CEO" ? "GD" : isProbationary ? "TV" : "NV",
                bp: 'SX',
                ...dayValuesOT,
                ngay_cong_thuong: gio_lam_them_ngay_thuong,
                ngay_cong_cn: gio_lam_them_ngay_cn,
                ngay_cong_le: gio_lam_them_ngay_le,
                ngay_cong: {formula: `ROUND(${getCol(sheetOT, 'ngay_cong_thuong')}${rowIndex}+${getCol(sheetOT, 'ngay_cong_cn')}${rowIndex}+${getCol(sheetOT, 'ngay_cong_le')}${rowIndex}, 0)`},
            } as PayrollRowCC);

            row.eachCell(cell => {
                cell.border = {
                    top: {style: 'thin'},
                    left: {style: 'thin'},
                    bottom: {style: 'thin'},
                    right: {style: 'thin'}
                };
                cell.font = {name: 'Times New Roman', size: 12};
                cell.alignment = {vertical: 'middle', horizontal: 'center'};
            });
            row.height = 24;
        });

    const totalRowOT = sheetOT.addRow({
        name: 'Tổng cộng',
    } as PayrollRowCC);

    const totalRowIndexOT = totalRowOT.number;
    const dayKeysOT: string[] = [];
    for (let day = 26; day <= numberOfDaysInMonth; day++) {
        dayKeysOT.push('day_' + day);
    }
    for (let day = 1; day <= 25; day++) {
        dayKeysOT.push('day_' + day);
    }
    dayKeysOT.forEach(key => {
        const colLetter = getCol(sheetOT, key as string);
        let total = 0;

        for (let row = startRowData; row <= totalRowIndexOT - 1; row++) {
            const cellValue = sheetOT.getCell(`${colLetter}${row}`).value;

            if (typeof cellValue === 'string') {
                total += calcHourFromCell(cellValue);
            }
        }
        sheetOT.getCell(`${colLetter}${totalRowIndexOT}`).value = total == 0 ? '' : total;
        /*{
            // formula: `=SUM(IF(${colLetter}${startRowData}:${colLetter}${totalRowIndexOT - 1}="","",ABS(--LEFT(RIGHT(${colLetter}${startRowData}:${colLetter}${totalRowIndexOT - 1},LEN(${colLetter}${startRowData}:${colLetter}${totalRowIndexOT - 1})-3),FIND("-",RIGHT(${colLetter}${startRowData}:${colLetter}${totalRowIndexOT - 1},LEN(${colLetter}${startRowData}:${colLetter}${totalRowIndexOT - 1})-3))-1)- --MID(RIGHT(${colLetter}${startRowData}:${colLetter}${totalRowIndexOT - 1},LEN(${colLetter}${startRowData}:${colLetter}${totalRowIndexOT - 1})-3),FIND("-",RIGHT(${colLetter}${startRowData}:${colLetter}${totalRowIndexOT - 1},LEN(${colLetter}${startRowData}:${colLetter}${totalRowIndexOT - 1})-3))+1,99))))`
            /!*formula: `=SUMPRODUCT(
                          IF(${colLetter}${startRowData}:${colLetter}${totalRowIndexOT - 1}="",
                             0,
                             ABS(
                               --LEFT(RIGHT(${colLetter}${startRowData}:${colLetter}${totalRowIndexOT - 1},LEN(${colLetter}${startRowData}:${colLetter}${totalRowIndexOT - 1})-3),FIND("-",RIGHT(${colLetter}${startRowData}:${colLetter}${totalRowIndexOT - 1},LEN(${colLetter}${startRowData}:${colLetter}${totalRowIndexOT - 1})-3))-1)
                              - --MID(RIGHT(${colLetter}${startRowData}:${colLetter}${totalRowIndexOT - 1},LEN(${colLetter}${startRowData}:${colLetter}${totalRowIndexOT - 1})-3),FIND("-",RIGHT(${colLetter}${startRowData}:${colLetter}${totalRowIndexOT - 1},LEN(${colLetter}${startRowData}:${colLetter}${totalRowIndexOT - 1})-3))+1,99)
                             )
                          )
                        )`*!/
        };*/
    });

    [
        'ngay_cong_thuong',
        'ngay_cong_cn',
        'ngay_cong_le',
        'ngay_cong'
    ].forEach(key => {
        const colLetter = getCol(sheetOT, key as string);
        sheetOT.getCell(`${colLetter}${totalRowIndexOT}`).value = {
            formula: `SUM(${colLetter}${startRowData}:${colLetter}${totalRowIndexOT - 1})`
        };
    });

    weekendColumns.forEach(key => {
        const colLetter = getCol(sheetOT, key);
        for (let row = startRow + 1; row <= totalRowIndexOT; row++) {
            sheetOT.getCell(`${colLetter}${row}`).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: {argb: 'FFD9D9D9'}
            };
        }
    });

    totalRowOT.eachCell(cell => {
        cell.border = {
            top: {style: 'thin'},
            left: {style: 'thin'},
            bottom: {style: 'thin'},
            right: {style: 'thin'}
        };
        cell.font = {name: 'Times New Roman', bold: true};
        cell.alignment = {vertical: 'middle', horizontal: 'center'};
    });
    totalRowOT.height = 24;

    // Save file
    // await workbook.xlsx.writeFile('bang_luong_2026.xlsx');
    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob(
        [buffer],
        {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
    );

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'BANG_LUONG_' + String(month).padStart(2, '0') + '_' + year + '.xlsx';
    link.click();
}

// generatePayslipExcel();